const prompts = [
  'Why did footfall drop?',
  'Which machines are underutilized?',
  'Which students are at risk?',
  'Predict next month usage',
  'Which workshop had highest attendance?',
  'Which machine has highest utilization?',
];

const SuggestedPrompts = ({ onSelect }) => {
  return (
    <div className="prompt-container">
      {prompts.map((prompt, index) => (
        <button
          key={index}
          className="prompt-chip"
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
};

export default SuggestedPrompts;